import axios, { AxiosPromise, AxiosResponse } from 'axios';
import { OrganizationHierarchy, OrganizationV2 } from '~/models';
import { VFairOrganization } from '~/services/types/vfair';
import { objectToQueryString } from '~/utils/urlUtils';

export interface GetCompaniesQuery {
    subdomain: string;
    page?: number;
    limit?: number;
    order?: string;
    minified?: boolean;
    query?: string;
    companyIds?: string[];
}

class CompanyService {
    static getCompany(id: number): AxiosPromise<OrganizationV2> {
        return axios({
            method: 'GET',
            url: `${process.env.VUE_APP_API_URL}v1/company/${id}`,
        });
    }

    static getCompanies(params: GetCompaniesQuery): AxiosPromise<OrganizationV2[]> {
        return axios({
            method: 'GET',
            url: `${process.env.VUE_APP_API_URL}v1/company`,
            params: params,
            paramsSerializer: params => {
                return objectToQueryString(params).slice(1);
            },
        });
    }

    static getVFairCompanies(
        vFairID: string,
        pavilionID?: string
    ): AxiosPromise<VFairOrganization[]> {
        return axios({
            method: 'GET',
            url: this.getVFairCompaniesUrl(vFairID, pavilionID),
        });
    }

    static getVFairCompany(
        vFairID: string,
        organizationID: string
    ): AxiosPromise<VFairOrganization> {
        return axios({
            method: 'GET',
            url: `${
                process.env.VUE_APP_API_URL
            }v1/vfair/${vFairID}/organizations/${organizationID}`,
        });
    }

    static getOrganizationHierarchy(
        orgId: number,
        minimal: boolean = false
    ): Promise<OrganizationHierarchy> {
        return axios({
            method: 'GET',
            url: `${process.env.VUE_APP_API_URL}v2/organizations/hierarchy/${orgId}`,
            params: {
                minimal: minimal,
            },
        }).then((res: AxiosResponse<OrganizationHierarchy>) => res.data);
    }

    private static getVFairCompaniesUrl(vFairID: string, pavilionID?: string) {
        return `${process.env.VUE_APP_API_URL}v1/vfair/${vFairID}/organizations${
            !pavilionID ? '' : `?pavilion_id=${pavilionID}`
        }`;
    }
}

export default CompanyService;
